import type { SpotlightProps } from '@atlaskit/onboarding/types';

const placementMap = {
	'top right': 'top-start',
	'top center': 'top-center',
	'top left': 'top-end',
	'right bottom': 'right-start',
	'right middle': 'right-start',
	'right top': 'right-end',
	'bottom left': 'bottom-end',
	'bottom center': 'bottom-center',
	'bottom right': 'bottom-start',
	'left top': 'left-end',
	'left middle': 'left-start',
	'left bottom': 'left-start',
} as const;

export const dialogPlacementTranslation = (
	value: SpotlightProps['dialogPlacement'],
):
	| 'top-start'
	| 'top-center'
	| 'top-end'
	| 'right-start'
	| 'right-end'
	| 'bottom-end'
	| 'bottom-center'
	| 'bottom-start'
	| 'left-end'
	| 'left-start' => {
	// `bottom left` is the default placement when `undefined` is passed.
	return placementMap[value || 'bottom left'];
};
